<template>
  <div class="space-y-3">
    <label
      v-for="option in visibilityOptions"
      :key="option.value"
      :class="[
        'flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-colors',
        modelValue === option.value
          ? 'bg-purple-600/20 border-purple-500'
          : 'bg-white/5 border-white/10 hover:border-white/20'
      ]">
      <input
        type="radio"
        :value="option.value"
        :checked="modelValue === option.value"
        class="mt-1 accent-purple-500"
        @change="$emit('update:modelValue', option.value)" />
      <div class="flex-1">
        <div class="flex gap-2 items-center">
          <fa-icon :icon="option.icon" class="text-white/60" />
          <span class="font-medium text-white">{{ option.label }}</span>
        </div>
        <p class="mt-1 text-sm text-white/50">
          {{ option.description }}
        </p>
      </div>
    </label>
  </div>
</template>

<script setup>
import { CLUB_VISIBILITY } from '@/stores/storeClubs'

defineProps({
  modelValue: {
    type: String,
    default: CLUB_VISIBILITY.EVERYONE
  }
})

defineEmits(['update:modelValue'])

const visibilityOptions = [
  {
    value: CLUB_VISIBILITY.EVERYONE,
    label: 'Everyone',
    icon: ['fas', 'globe'],
    description: 'Anyone can discover this club and see its content'
  },
  {
    value: CLUB_VISIBILITY.MEMBERS_ONLY,
    label: 'Members Only',
    icon: ['fas', 'users'],
    description: 'Discoverable, but only members can see club content'
  },
  {
    value: CLUB_VISIBILITY.HIDDEN,
    label: 'Hidden',
    icon: ['fas', 'eye-slash'],
    description: 'Only members can see this club exists'
  }
]
</script>
